import { render, staticRenderFns } from "./index.vue?vue&type=template&id=462c893d&scoped=true&style=height%3A100%25"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462c893d",
  null
  
)

export default component.exports